import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import classnames from 'classnames';
import Slider from 'react-slick';

const slidesJump = 4;

const settings = (onSlide) => ({
  infinite: false,
  speed: 500,
  slidesToShow: slidesJump,
  slidesToScroll: slidesJump,
  arrows: false,
  variableWidth: true,
  swipeToSlide: true,
  beforeChange: () => onSlide(false),
  afterChange: () => onSlide(true)
});

const PortsCountries = ({showArrows, popularPorts, onChangePopularPortCountry, translations}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [isEnabled, setIsEnabled] = useState(true);
  const sliderRef = useRef();

  const {filters: {countries}} = popularPorts;

  const nofCountries = countries.length;

  const selectedCountry = countries.find(({selected}) => selected);
  const restCountries = countries.filter(({selected}) => !selected);

  const onPrevious = () => {
    const slide = slideIndex - slidesJump;
    if (isEnabled && slide >= 0) {
      setSlideIndex(slide);
      sliderRef.current.slickGoTo(slide);
    }
  };

  const onNext = () => {
    const slide = slideIndex + slidesJump;
    if (isEnabled && slide <= nofCountries - slidesJump) {
      setSlideIndex(slide);
      sliderRef.current.slickGoTo(slide);
    }
  };

  const onSlide = (value) => {
    setIsEnabled(value);
  };

  return (
    <>
      <div className="mb-3">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="font-bold">{translations.filterbyCountry}</div>
          {showArrows && <div>
            <i
              className="icon icon-left-arrow text-primary"
              aria-hidden="true"
              style={{opacity: slideIndex > 0 ? 1 : 0.5}}
              onClick={onPrevious}
            />
            <i
              className="icon icon-right-arrow text-primary"
              aria-hidden="true"
              style={{opacity: slideIndex < nofCountries - slidesJump ? 1 : 0.5}}
              onClick={onNext}
            />
          </div>}
        </div>
        <div id="popular-countries-slider" className="d-flex overflow-hidden">
          {
            selectedCountry &&
              <div
                className="d-flex align-items-center justify-content-center bg-white position-relative"
                style={{zIndex: 2}}
              >
                <div
                  className="d-flex align-items-center border border-primary px-2 py-1 cursor-pointer 
                  rounded text-center bg-primary text-white"
                  onClick={() => onChangePopularPortCountry(popularPorts, selectedCountry.code, true)}
                >
                  {selectedCountry.name}
                  <i className="icon icon-e-remove-1 ml-2" />
                </div>
                <span className="pl-1" style={{borderRight: '1px solid #999999', height: '34px'}}>
                  &nbsp;
                </span>
              </div>
          }
          <Slider ref={sliderRef} {...settings(onSlide)}>
            {restCountries.map(({code, name}, index) => {
              const countryClasses = classnames('d-inline-flex align-items-center justify-content-center', {
                'ml-1': index === nofCountries - 1,
                'mr-1': !selectedCountry && index === 0,
                'mx-1': (selectedCountry && index === 0) || (index !== 0 && index !== nofCountries - 1)
              });

              return (
                <div key={code} className={countryClasses}>
                  <div
                    className="border border-primary px-2 py-1 cursor-pointer rounded 
                    text-center text-primary"
                    onClick={() => onChangePopularPortCountry(popularPorts, code, false)}
                  >
                    {name}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
      <div className="my-3 two-border-top-dotted" />
    </>
  );
};

PortsCountries.defaultProps = {
  showArrows: false
};

PortsCountries.propTypes = {
  showArrows: PropTypes.bool.isRequired,
  popularPorts: PropTypes.object.isRequired,
  onChangePopularPortCountry: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    filterbyCountry: PropTypes.string.isRequired
  })
};

export default observer(PortsCountries);
